import { Producer, createDefaultProducer } from './producer';
import { Person, createDefaultPerson } from './person';
import { ACHPayment, createDefaultACHPayment } from './achPayment';
import { IDUpload } from './idUpload';

 // Form data model containing all steps
export interface SignupData {
    signedByName: string;
    signedByEmail: string;

    hasReinsurance: boolean;

    // Producers
    noFinanceCompanyAck: boolean;
    producers: Producer[];

    // Basic Reinsurance Info
    reinsuranceName1: string;
    reinsuranceName2: string;
    reinsuranceName3: string;

    products: string[];

    // Reinsurance Contact
    reinsuranceContactName: string;
    reinsuranceContactRelation: string;
    reinsuranceContactEmail: string;
    reinsuranceContactPhone: string;
    reinsuranceContactAccountingEmail: string;
    reinsuranceContactPhysicalAddressLines: string;
    reinsuranceContactPhysicalCity: string;
    reinsuranceContactPhysicalState: string;
    reinsuranceContactPhysicalCounty: string;
    reinsuranceContactPhysicalZip: string;
    reinsuranceContactMailingEnabled: boolean;
    reinsuranceContactMailingAddressLines: string;
    reinsuranceContactMailingCity: string;
    reinsuranceContactMailingState: string;
    reinsuranceContactMailingZip: string;
    shareholdersHaveOtherOwnership: boolean;
    otherOwnershipDetails: string;

    // Added full address fields for convenience
    reinsuranceContactPhysicalFullAddress?: string;
    reinsuranceContactMailingFullAddress?: string;

    reinsuranceFormationFee: number;
    reinsuranceManagementFee: number;

    // Shareholders
    people: Person[];

    // ID Uploads
    idUploads: Record<string, IDUpload>; // Maps unique names to uploaded files

    // ACH Payment
    ach: ACHPayment;
}

/**
 * Creates a default SignupData object
 */
export function createDefaultSignupData(): SignupData {
    return {
        signedByName: "",
        signedByEmail: "",
        hasReinsurance: false,
        noFinanceCompanyAck: false,
        producers: [createDefaultProducer()],
        reinsuranceName1: "",
        reinsuranceName2: "",
        reinsuranceName3: "",
        products: [],
        reinsuranceContactName: "",
        reinsuranceContactRelation: "",
        reinsuranceContactEmail: "",
        reinsuranceContactPhone: "",
        reinsuranceContactAccountingEmail: "",
        reinsuranceContactPhysicalAddressLines: "",
        reinsuranceContactPhysicalCity: "",
        reinsuranceContactPhysicalState: "",
        reinsuranceContactPhysicalCounty: "",
        reinsuranceContactPhysicalZip: "",
        reinsuranceContactMailingEnabled: false,
        reinsuranceContactMailingAddressLines: "",
        reinsuranceContactMailingCity: "",
        reinsuranceContactMailingState: "",
        reinsuranceContactMailingZip: "",
        shareholdersHaveOtherOwnership: false,
        otherOwnershipDetails: "",
        reinsuranceFormationFee: 0,
        reinsuranceManagementFee: 0,
        people: [createDefaultPerson()],
        idUploads: {},
        ach: createDefaultACHPayment()
    };
}